import React, { useContext, useState, useEffect } from 'react';
import { Button, Upload, Modal } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import * as utils from '../../utils';
import { Context } from '../../defaults';


const ViewDocument = ({ files }) => {
    const { dictionary, language } = useContext(Context);
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [previewTitle, setPreviewTitle] = useState('');
    const [fileList, setFileList] = useState([]);



    const handleCancel = () => {
        setPreviewVisible(false);
    }

    const handlePreview = async file => {
        const extension = file.extension?.trim();
        console.log('extension', `${extension}!`, extension === 'jрg');
        if (extension === 'jpeg' || extension === 'jpg' || extension === 'bmp' || extension === 'gif' || extension === 'png') {

            if (!file.url && !file.preview) {
                file.preview = await utils.getBase64(file.originFileObj);
            }
            setPreviewImage(file.url || file.preview);
            setPreviewVisible(true);
            setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
        }
        else {
            window.open(file.url || file.preview, '_blank');
        }

    };



    useEffect(() => {
        if (files && files.length > 0) {
            setFileList([...files].map((el, i) => { return { uid: i, status: 'done', name: '', extension: el.extension, url: el.link } }));
        }
        else {
            setFileList([]);
        }
    }, [files]);

    return (
        <>
            <Upload
                listType='picture-card'
                fileList={fileList}
                onPreview={handlePreview}
                style={{ textAlign: 'left' }}
                showUploadList={{ showRemoveIcon: false }}
            />
            <Modal
                visible={previewVisible}
                title={previewTitle}
                footer={null}
                onCancel={handleCancel}
                width={1000}
            >
                <img alt='example' style={{ width: '100%' }} src={previewImage} />
            </Modal>
            {/* {
                files && files.map(el => {
                    const { extension, link } = el;
                    if (extension) {
                        if (extension === 'jpeg' || extension === 'jpg' || extension === 'bmp' || extension === 'gif' || extension === 'png') {
                            return <img alt={''} src={'https://i.pinimg.com/originals/78/8a/b4/788ab42238ae2488fa93964315e088b0.jpg'} style={{ width: '100%', height: '100%' }} />
                        }
                        else {
                            return <a href={link} target='_blank' rel='noopener noreferrer' style={{ marginRight: 20, marginBottom: 20 }}><Button icon={<DownloadOutlined />}>{dictionary?.DownloadFile[language]}</Button></a>
                        }
                    }
                    else return <a href={link} target='_blank' rel='noopener noreferrer' style={{ marginRight: 20, marginBottom: 20 }}><Button icon={<DownloadOutlined />}>{dictionary?.DownloadFile[language]}</Button></a>;
                })
            } */}
        </>
    );

}

export default ViewDocument;